import React from "react";
import { Text } from "@jsq/ds/core";

export type WireInfoFieldProps = {
  wireInfo?: Record<string, string | null> | null;
};
export const WireInfoField: React.FC<WireInfoFieldProps> = (props) => {
  const { wireInfo } = props;

  const hasWireInfo =
    wireInfo &&
    Object.entries(wireInfo).some(([key, value]) => {
      return key !== "__typename" && !!value;
    });

  if (!hasWireInfo) {
    return null;
  }

  return (
    <>
      {Object.entries(wireInfo).map(([key, value]) => {
        if (key === "__typename" || !value || value === "None") {
          return null;
        }
        return (
          <div key={key}>
            <Text variant="regular-sm">{value}</Text>
          </div>
        );
      })}
    </>
  );
};

export default WireInfoField;
